import { render, staticRenderFns } from "./UploadSiteLogo.vue?vue&type=template&id=86fb4be4&"
import script from "./UploadSiteLogo.vue?vue&type=script&lang=js&"
export * from "./UploadSiteLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports